import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { FormattedMessage as T } from "react-intl";
import UserSkusTable from "./UserSkusTable";

type UserSkusListProps = {
  userId: string;
  organizationId: string;
};

export const UserSkusList = ({ userId, organizationId }: UserSkusListProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>
          <T id="userCoursesTitle" />
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box mb={2}>
          {expanded && (
            <UserSkusTable
              {...{
                userId,
                organizationId,
              }}
            />
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
